var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 0L0 4.52078L7.25 8.97507L14.5 4.52078L7.25 0ZM21.75 0L14.5 4.52078L21.75 8.97507L29 4.52078L21.75 0ZM0 13.4958L7.25 18.0166L14.5 13.4958L7.25 8.97507L0 13.4958ZM21.75 8.97507L14.5 13.4958L21.75 18.0166L29 13.4958L21.75 8.97507ZM7.25 19.4792L14.5 24L21.75 19.4792L14.5 15.0249L7.25 19.4792Z",
    fill: "#0062FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropbox);
export default __webpack_public_path__ + "static/media/dropbox.863728e55e49d1c06cf80c4914b5f5c1.svg";
export { ForwardRef as ReactComponent };